<template>
  <div id="GButton" class="validacion" v-bind:class="[isForResponsive]" @click="doLogin">
    <span>LOGIN CON Google</span>
    <img :src="google" style="width: 15px; margin-left: 10px;" />
  </div>
</template>

<script>
import google from '@/assets/google.png';
import axios from 'axios';
import {sha256} from 'js-sha256';
import tagFunctions from '@/utils/tagFunctions.js'


export default {
  name: "GoogleButton",
  data() {
    return {
      google,
      auth: null,
    };
  },
  props: {
    isForResponsive: null,
    tycos: false,
    privacy: false
  },
  mounted() {
    //  const firebaseConfig = {
    //    apiKey: "AIzaSyAqiDUc-BLTlfsk8p8ydpUvb-jTH_ZjQUE",
    //    authDomain: "hmex-prd.firebaseapp.com",
    //    appId: "6245795e6ae4671b60a4aa78"
    //  };

    //  // Initialize Firebase
    //  const app = initializeApp(firebaseConfig);
    //  this.auth = getAuth(app);

    window.gapi.load("client:auth2", () => {
             this.loaded = true;
            this.GoogleAuth = window.gapi.auth2.init({
              client_id: '875258040709-kt2pek7gtnltf3jrsdis6rubsbphkrdi.apps.googleusercontent.com',
              scope: 'email',
              plugin_name: "chat"
            });
            this.GoogleAuth.then((result) => {
                // this.sdkConfigured();
                console.log(result)
            });
       });
  },
  methods: {
    doLogin: function () {
      if(this.tycos && this.privacy){
        this.GoogleAuth.signIn()
            .then(() => {
                this.GoogleUser = this.GoogleAuth.currentUser.get();
                const prof = this.GoogleUser.getBasicProfile();
                const profile = {
                    id: prof.getId(),
                    name: prof.getName(),
                    given_name: prof.getGivenName(),
                    family_name: prof.getFamilyName(),
                    image_url: prof.getImageUrl(),
                    email: prof.getEmail()
                };
                const auth = this.GoogleUser.getAuthResponse();
              //  console.log(auth, profile)
               this.xeerpaRequest(auth.access_token, profile.id, profile.email).then(() =>{
                // this.sendEmail(profile.email);
               })
            })
            .then(undefined, (error) => {
                console.error(error);
            
            });
          }else{
         this.$emit('errorTycos', !this.tycos)
         this.$emit('errorPrivacy', !this.privacy)
    }
      //    signInWithPopup(this.auth, provider).then((result) => {
      //    const credential = GoogleAuthProvider.credentialFromResult(result);
      //    const token = credential.accessToken;
      //    // The signed-in user info.
      //    const user = result.user;
      //    console.log(result);
      //    this.xeerpaRequest(user.accessToken, user.uid);
      //  }).catch((error) => {
      //    const errorCode = error.code;
      //    const errorMessage = error.message;
      //    // The email of the user's account used.
      //    const email = error.customData.email;
      //    // The AuthCredential type that was used.
      //    const credential = GoogleAuthProvider.credentialFromError(error);
      //  })
      //  }else{
      //    this.$emit('error', true)
      //  }
   
      // window.FB.login(
      //   function (response) {
      //     // console.log('response',response)
      //     // debugger
      //     if (response.status === "connected") {
      //       window.FB.api(
      //         "/me?fields=birthday,email,name",
      //         function (meResponse) {
      //           // console.log(meResponse);
      //           const xeerpaNeeded = {
      //             ...response,
      //             birthday: meResponse.birthday,
      //           };
      //           meResponse.birthday
      //             ? vm.$emit("fbLogin", xeerpaNeeded)
      //             : vm.$emit("noBirthdayInFacebook");
      //         }
      //       );
      //     }
      //   },
      //   { scope: "public_profile,email,user_birthday" }
      // );
    },

    async xeerpaRequest(accessToken, userID, email){
      this.$emit('loading', true)
      const hash = sha256(email)
      const resp = await axios.get(`https://cuamoc.xeerpa.com:8443/discoveruser?clientId=6149a1372dfd6f0d347b6458&clientPwd=yyipHjnqJg&appId=63e0e67da94e170f88ad07d9&socialNetwork=GO&userId=${userID}&userToken=${accessToken}&robinson=false&id=${hash}`);
      this.$emit('success', email)
      tagFunctions.evRegisterPush('Login con google');
      pintrk('track', 'signup', {property: 'RegistroConGoogle'});
      return resp
    },
 
  },
};
</script>

<style scoped lang="scss">
@import "~@/styles/variables.scss";

#GButton {
  background-color: $black;
  color: $white;
  font-family: $font-TerminaLight;
  background-position: center center;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5vw;
  width: 75%;
  height: 25px;
  max-width: 250px;
  margin-top: 5px;
  text-transform: uppercase;

  @media (max-width: 500px) {
    font-size: 1.5vw;
  }

  letter-spacing: 0.2vw;

  &:hover {
    cursor: pointer;
  }

  span {
    margin-top: 0vw;
    //line-height: 50%;
  }

  @media screen and (max-width: 380px) {
        height: 25px;
    }

  @media screen and (min-width: 768px) {
    font-size: clamp(0.6rem, 1vw, 0.8rem);
    max-width: 350px;
    height: 30px;
    margin-top: 10px;
  }
}
</style>
